interface LoadingScreenProps {
  label?: string;
}

/** Shown while the session or a route is still resolving. */
export function LoadingScreen({ label = 'Wird geladen …' }: LoadingScreenProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[60dvh] flex-col items-center justify-center gap-4"
    >
      <span
        aria-hidden
        className="border-line border-t-brand size-8 animate-spin rounded-full border-2"
      />
      <span className="text-fg-muted text-sm">{label}</span>
    </div>
  );
}
